import { render, staticRenderFns } from "./matchSubItem.vue?vue&type=template&id=2a3be6ff&scoped=true&"
import script from "./matchSubItem.vue?vue&type=script&lang=js&"
export * from "./matchSubItem.vue?vue&type=script&lang=js&"
import style0 from "./matchSubItem.vue?vue&type=style&index=0&id=2a3be6ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3be6ff",
  null
  
)

export default component.exports